import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';
import {WindowRef} from '@spartacus/core';
import {LaunchDialogService} from '@spartacus/storefront';

import {AimoCart, AimoOrderEntry} from '../../../model/cart.model';
import {AimoGTMProductAttributes, GTMCartType, GTMItemListId} from '../../../service/gtm/aimo-gtm.model';
import {AimoGtmService} from '../../../service/gtm/aimo-gtm.service';
import {AimoProductService} from '../../../service/product/aimo-product.service';

@Component({
    selector: 'aimo-order-template-item-list',
    templateUrl: './aimo-order-template-item-list.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AimoOrderTemplateItemListComponent implements OnInit {
    @Input()
    orderTemplate: AimoCart;

    @Input()
    cart: AimoCart;

    @Input()
    baseOrder: boolean = false;

    @Input()
    printViewWithTable: boolean = false;

    constructor(
        protected winRef: WindowRef,
        protected launchDialogService: LaunchDialogService,
        protected gtmService: AimoGtmService,
        protected productService: AimoProductService,
    ) {
    }

    ngOnInit(): void {
        if (!this.baseOrder) {
            let idx = 0;
            this.productService.fireProductListViewGtmEvent(
                this.orderTemplate.categoryGroupedEntries
                    ?.flatMap(e => e.entries)
                    ?.map((e) => ({
                        ...e.product,
                        gtmProductAttributes: this.createGtmAttributes(idx++, e)
                    }))
            );
        }
    }

    // eslint-disable-next-line
    createGtmAttributes(idx: number, entry: AimoOrderEntry): AimoGTMProductAttributes {
        return {
            ...this.gtmService.createProductGtmAttributesBase(entry.product, GTMItemListId.order_template),
            cart_type: this.baseOrder ? GTMCartType.baseOrder : GTMCartType.orderTemplate,
        };
    }

    getAlreadyAddedToCart(cart: AimoCart, entry: AimoOrderEntry): number {
        return cart?.dayGroupedEntries
            ?.filter((g) => g.active)
            .flatMap((g) => g.entries)
            .find((e) => e.product.code === entry.product.code)?.quantity;
    }
}
